import useIntl from '@/infrastructure/hooks/useIntl';
import trackUserAction from '@/infrastructure/sentry/useTrackEvent';
import { ActionIcon, Menu, rem } from '@mantine/core';
import { FC, useState } from 'react';

import DotsVertical from '@assets/dots-vertical.svg';
import StartNew from '@assets/refresh-cw-01.svg';

import styles from './index.module.css';

interface IProps {
  resetChat: () => void;
}

const ChatMenu: FC<IProps> = ({ resetChat }) => {
  const t = useIntl('chat');
  const [opened, setOpened] = useState(false);

  return (
    <Menu
      opened={opened}
      onChange={setOpened}
      position="bottom-start"
      offset={3}
      classNames={{ dropdown: styles.dropdown }}
    >
      <Menu.Target>
        <ActionIcon variant="outline" color="d1gray.3" radius="md" size="lg">
          <DotsVertical />
        </ActionIcon>
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Item
          onClick={() => {
            resetChat();
            trackUserAction(`Clicked on restart chat`);
          }}
          leftSection={<StartNew style={{ width: rem(14), height: rem(14) }} />}
        >
          {t('menu.startOverOption')}
        </Menu.Item>
        {/* <Menu.Item
          leftSection={<History style={{ width: rem(14), height: rem(14) }} />}
          onClick={showNotification}
        >
          {t('menu.chatHistoryOption')}
        </Menu.Item> */}
      </Menu.Dropdown>
    </Menu>
  );
};

export default ChatMenu;
